var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChicken = function SvgChicken(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9602_8790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9602_8790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0.304688H0.5V21.6947H21.5V0.304688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9602_8790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.73999 6.45501C2.67999 6.41501 2.60999 6.41501 2.54999 6.43501L1.10999 7.05501C1.02999 7.08501 0.98999 7.16501 0.98999 7.24501C0.98999 7.32501 1.03999 7.40501 1.10999 7.43501L2.54999 8.05501C2.54999 8.05501 2.59999 8.07501 2.62999 8.07501C2.66999 8.07501 2.70999 8.06501 2.73999 8.04501C2.79999 8.00501 2.82999 7.94501 2.82999 7.87501V6.63501C2.82999 6.56501 2.79999 6.50501 2.73999 6.46501V6.45501Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49992 6.69516C5.31992 6.69516 5.16992 6.54516 5.16992 6.36516C5.16992 6.18516 5.31992 6.03516 5.49992 6.03516C5.67992 6.03516 5.82992 6.18516 5.82992 6.36516C5.82992 6.54516 5.67992 6.69516 5.49992 6.69516Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 4.03508V3.70508H17.5001C15.1501 3.70508 12.9701 5.07508 11.9601 7.20508L10.5001 10.2651L8.17008 5.38508C7.74008 4.44508 6.83008 3.79508 5.79008 3.71508C5.05008 3.66508 4.33008 3.91508 3.77008 4.40508C3.21008 4.89508 2.88008 5.57508 2.83008 6.31508C2.83008 6.37508 2.83008 6.43508 2.83008 6.49508V11.5451C2.83008 15.6751 6.20008 19.0451 10.3301 19.0451C14.3501 19.0451 17.6101 15.4651 17.8201 12.3651C19.3201 12.2051 20.5001 10.9251 20.5001 9.38508V9.05508H19.3801C20.0601 8.50508 20.5001 7.66508 20.5001 6.72508V6.39508H19.3801C20.0601 5.84508 20.5001 5.00508 20.5001 4.06508V4.03508Z",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9602_8790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21.39,
    fill: "white",
    transform: "translate(0.5 0.304688)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChicken);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chicken.348cfce133712104c8b744938ff1218b.svg";